import { ToggleGroupItem } from "./ToggleGroupItem";
import { ToggleGroupRoot } from "./ToggleGroupRoot";
export const ToggleGroup = {
  Item: ToggleGroupItem,
  Root: ToggleGroupRoot
};
//# sourceMappingURL=ToggleGroup.js.map